enum Status {
  '正常',
  '禁用'
}
export default Status;
